<!-- Root layout container -->
<div class="app-layout d-flex">

  <!-- SIDEBAR  -->
   <div app-acms-sidebar (sidebarToggled)="onSidebarState($event)"></div> 


   <!-- MAIN -->
  <div class="main-column flex-grow-1 d-flex flex-column" [class.collapsed]="sidebarCollapsed">
    <!-- Header -->
    <header class="navbar" app-header></header>
    <main class="sidebar-content">
      <router-outlet></router-outlet>
    </main>
    <!-- Footer -->
    <footer class="footer" app-footer></footer>
  </div>
</div>